import { observable } from 'mobx';

export type RoomElementResponseArgs = {
  id: number;
  name: string;
};

export type RoomElementArgs = {
  id: number;
  name: string;
};

export const convertRoomElementResponseToArgs = (response: RoomElementResponseArgs) => {
  const args: RoomElementArgs = {
    id: response.id,
    name: response.name
  };
  return args;
};

export default class RoomElement {
  @observable
  id: number;

  @observable
  name: string;

  constructor(args: RoomElementArgs) {
    this.id = args.id;
    this.name = args.name;
  }

  get type() {
    return 'room';
  }

  get title() {
    return '会議室';
  }

  get summary() {
    return `[会議室]${this.name}`;
  }

  detail() {
    return '';
  }
}
